import axios from 'axios';
import StaticSingleton from '../Shared/StaticSingleton';
import URLs from './URLs';

class MediaServer extends StaticSingleton<MediaServer> {
    Get (resource: string) {
        const mediaServerURL = URLs.mediaServer;
        if (!mediaServerURL) {
            throw new Error("Missing media server URL!");
        }
        const URL = mediaServerURL + resource;
        if (!resource) 
            throw new Error("Missing API resource name!");
        
        return axios
            .get(URL)
            .then((response) => response.data);
    }
}

export default new MediaServer();